/** Official Saudi Riyal symbol — light/dark variants in src/assets/ */
import saudiRiyalSymbol from '../assets/saudi-riyal-symbol.png';
import saudiRiyalSymbolDark from '../assets/saudi-riyal-symbol-dark.png';

export { saudiRiyalSymbol, saudiRiyalSymbolDark };

/** Numeric portion only (e.g. "300.00") for affiliate SAR amounts */
export const formatAffiliateAmount = (amount) => {
  const num = parseFloat(amount);
  if (isNaN(num)) {
    return '0.00';
  }

  return num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};
